import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import download from "../../assets/download.png";
import footer_logo from "../../assets/footer_logo.png";
import { APPLE_STORE_URL, GOOGLE_STORE_URL } from "../../utils/constants";
import { Link } from "react-router-dom";

const AppDownloadSection = () => {
  const styles = {
    sectionWrapper: {
      background: "linear-gradient(to bottom, #ffffff 60%, #1a1a1a 40%)",
      color: "#000",
      paddingTop: "50px",
      paddingBottom: "0",
      display: "flex",
      justifyContent: "center",
      marginTop: "3%",
    },
    promoBox: {
      backgroundColor: "#2a2a2a",
      borderRadius: "20px",
      padding: "40px",
      color: "white",
      position: "relative",
      marginBottom: "0",
    },
    heading: {
      fontSize: "2.5rem",
      fontWeight: "700",
    },
    paragraph: {
      color: "#ccc",
      marginTop: "15px",
      marginBottom: "30px",
    },
    storeButtons: {
      display: "flex",
      gap: "10px",
      marginBottom: "20px",
    },
    footer: {
      backgroundColor: "#1a1a1a",
      color: "white",
      paddingTop: "60px",
      paddingBottom: "40px",
    },
    footerTitle: {
      fontWeight: "600",
      marginBottom: "10px",
    },
    footerText: {
      color: "#ccc",
      marginBottom: "6px",
      textDecoration: "none",
    },
    copyRight: {
      borderTop: "1px solid #333",
      paddingTop: "20px",
      fontSize: "14px",
      marginTop: "30px",
    },
  };

  return (
    <div>
      <div style={styles.sectionWrapper}>
        <Container className="footer_container_section1">
          <div style={styles.promoBox}>
            <Row>
              <Col md={6}>
                <h2 style={styles.heading}>Get the app!</h2>
                <label style={styles.paragraph}>
                  Join a vibrant community where you can create unforgettable
                  moments or connect with others who share your passions—all at
                  your fingertips!
                </label>
                <div style={styles.storeButtons}>
                  <a href={APPLE_STORE_URL} target="_blank">
                    <img src="./images/Frame 11.png" alt="Google Play" />
                  </a>
                  <a
                    href={GOOGLE_STORE_URL}
                    style={{ marginRight: "3%" }}
                    target="_blank"
                  >
                    <img src="./images/Badge.png" alt="App Store" />
                  </a>
                </div>
              </Col>
              <Col md={6} style={{ display: "flex", justifyContent: "end" }}>
                <Image
                  src={download}
                  alt="App Preview"
                  className="imageStyle"
                  fluid
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <div style={styles.footer}>
        <Container>
          <Row>
            <Col xl={6} lg={6} md={12} sm={12}>
              <div style={{ fontSize: "2.5rem", fontWeight: "700" }}>
                <Image src={footer_logo} alt="Footer Logo" fluid />
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={12}
              className="footer_sitemap_section_spacing"
            >
              <div style={styles.footerTitle}>Sitemap</div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Link
                  to={"/products/category/Pets and Animals"}
                  style={styles.footerText}
                >
                  Products
                </Link>
                <Link to={"/services"} style={styles.footerText}>
                  Services
                </Link>
                <Link to={"/membership"} style={styles.footerText}>
                  Membership
                </Link>
                <Link to={"/partnerwithus"} style={styles.footerText}>
                  Partner with us
                </Link>
                <Link to={"/aboutus"} style={styles.footerText}>
                  About us
                </Link>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={12}
              className="footer_sitemap_section_spacing"
            >
              <div style={styles.footerTitle}>Social</div>
              <div style={styles.footerText}>
                <a
                  href="https://www.instagram.com/my_by_greggii/?igsh=MXU2Z21raWtmcnVneg%3D%3D#"
                  target="_blank"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  Instagram
                </a>
              </div>
              <div style={styles.footerText}>
                <a
                  href="https://www.linkedin.com/in/my-by-greggii-557052235/"
                  target={"_blank"}
                  style={{ color: "white", textDecoration: "none" }}
                >
                  LinkedIn
                </a>
              </div>
              <div style={styles.footerText}>
                <a
                  href="https://twitter.com/my_greggii"
                  target={"_blank"}
                  style={{ color: "white", textDecoration: "none" }}
                >
                  Twitter/X
                </a>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={4}
              sm={12}
              className="footer_sitemap_section_spacing"
            >
              <div style={styles.footerTitle}>Get the App!</div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <a href={APPLE_STORE_URL} target="_blank">
                  <img src="./images/Frame 11.png" alt="Google Play" />
                </a>
                <a
                  href={GOOGLE_STORE_URL}
                  target="_blank"
                  style={{ marginTop: "2%" }}
                >
                  <img src="./images/Badge.png" alt="App Store" />
                </a>
              </div>
            </Col>
          </Row>
          <div style={styles.copyRight}>
            © {new Date().getFullYear()} Myooo — All Rights Reserved.
          </div>
        </Container>
      </div>
    </div>
  );
};

export default AppDownloadSection;
